import { Component, OnInit } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { LoginService } from '../services/login.service';
import { SharedService } from '../services/shared.service';
import { UserService } from '../services/user.service';
import { User } from '../model/User.model';
import { Router } from '@angular/router';

@Component({
  selector: 'gf2-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  shared: SharedService;

  user: User;
  u: User;
  isAdmin = false;
  isRepres = false;
  isClient = false;
  
  constructor(
    private userService: UserService,
    private loginService: LoginService,
    private storageService: StorageService,
    private route: Router
  ) { 
    this.userService.userEmitter.subscribe(res => {
      this.user = res;      
    });

    this.shared = SharedService.getInstance();

    let localUser = this.storageService.getLocalUser();

    if (!localUser) {
      this.shared.showTemplate.emit(false);
      this.route.navigate(['/']);
      localStorage.clear();
    } else {
      this.u = this.storageService.getUserLogged();        
    }

    this.shared.admin.subscribe( res => {
      if(res) {
        this.isAdmin = res;
      }
    })
    this.shared.repres.subscribe( res => {
      if(res) {
        this.isRepres = res;
      }
    })
    this.shared.client.subscribe( res => {
      if(res) {
        this.isClient = res;
      }
    })
  }

  ngOnInit() {
    this.user = this.storageService.getUserLogged();
    
  }

  goToDetail(user: User) {
    this.route.navigate(['user-detail'],
    { queryParams: { userId : user.id} });
  }

  logout() {
    this.loginService.logout();
    this.shared.showTemplate.emit(false);
  }
}
